//
// Generated class APPCC_List
//

/// <reference path="APPCC_List_ManagedObject.ts" />

class APPCC_List extends APPCC_List_ManagedObject
{

}
